import {createAction} from 'redux-actions';

const PREFIX = 'BUSINESSPAGE_';

export const getBusinessPageProfile = createAction(`${PREFIX}GET_PROFILE`);
export const getBusinessPageProfileSuccess = createAction(
  `${PREFIX}GET_PROFILE_SUCCESS`,
  (payload) => payload,
);
export const getBusinessPageProfileFailure = createAction(
  `${PREFIX}GET_PROFILE_FAILURE`,
  (payload) => payload,
);

export const getUserReviews = createAction(`${PREFIX}GET_USER_REVIEWS`);
export const getUserReviewsSuccess = createAction(
  `${PREFIX}GET_USER_REVIEWS_SUCCESS`,
  (payload) => payload,
);
export const getUserReviewsFailure = createAction(
  `${PREFIX}GET_USER_REVIEWS_FAILURE`,
  (payload) => payload,
);
